<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:25:51 +0800
 * @最后修改时间: 2022-03-07 14:02:36
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Leave\LeaveReason\editLeaveReason.vue
 -->

<template>
  <ContentLayout
    :title="
      iSEdited
        ? $t('label_essweb_leaveReason_form_editTitle')
        : $t('label_essweb_leaveReason_form_viewTitle')
    "
    widthClass="max-1000"
    delBtn
    backgroundClass="white"
    :editBtn="!iSEdited"
    @edit="iSEdited = true"
    :initData="LeaveReasonData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'leave_reason_name',
      'sequence',
      'leave_reason_description',
      'leave_reason_code',
      'leave_type_uuid',
      'remarks',
    ]"
    @delete="
      $confirmDo($t('label_essweb_leaveReason_list_title')).then((res) => {
        res ? toDelete() : null;
      })
    "
  >
    <!-- content -->
    <template v-slot:page-main>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <inputTextFiledMultiLang
              maxlength="100"
              :filled="iSEdited"
              :readonly="!iSEdited"
              :bindData="LeaveReasonData.leave_reason_name"
              @change="
                (valueArr) => {
                  LeaveReasonData.leave_reason_name = valueArr;
                }
              "
              :label="$t('label_essweb_leaveReason_form_leaveReasonNameLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_leaveReason_form_leaveTypeLabel")
            }}</v-sheet>
            <v-autocomplete
              :items="leaveType"
              item-text="leave_type_name"
              item-value="uuid"
              :rules="$GetRules(['_Require_Rules'], [null])"
              dense
              :append-icon="iSEdited ? 'arrow_drop_down' : ''"
              :placeholder="$t('label_essweb_leaveReason_form_leaveTypeLabel')"
              v-model="LeaveReasonData.leave_type_uuid"
              :filled="iSEdited"
              :readonly="!iSEdited"
              single-line
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-autocomplete>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              :filled="iSEdited"
              :readonly="!iSEdited"
              maxlength="10"
              type="number"
              isNotRequire
              :rules="
                $GetRules(['_Number_negative', '_Length_Rules'], [null, 10])
              "
              :label="$t('label_essweb_leaveReason_form_sequenceLabel')"
              v-model="LeaveReasonData.sequence"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              :filled="iSEdited"
              maxlength="50"
              :readonly="!iSEdited"
              :label="$t('label_essweb_leaveReason_form_codeLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
              v-model="LeaveReasonData.leave_reason_code"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :bindData="LeaveReasonData.leave_reason_description"
              maxlength="500"
              @change="
                (valueArr) => {
                  LeaveReasonData.leave_reason_description = valueArr;
                }
              "
              :filled="iSEdited"
              :readonly="!iSEdited"
              :label="$t('label_essweb_leaveReason_form_descriptionLabel')"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveReason_form_RemarkLabel")
            }}</v-sheet>
            <v-textarea
              rows="5"
              no-resize
              maxlength="500"
              v-model="LeaveReasonData.remarks"
              dense
              counter="500"
              single-line
              :filled="iSEdited"
              :readonly="!iSEdited"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        v-if="iSEdited"
        saveBtn
        @save="toSave"
        @cancel="$toBack(isChanged)"
      />
    </template>
    <!-- actions -->
    <template v-slot:tools-main> </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "editLeaveReason",
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
    leaveType() {
      return this.$getSelectTrans(this.leaveTypeData, "leave_type_name");
    },
  },
  data() {
    return {
      iSEdited: true,
      isChanged: false,
      leaveTypeData: [],
      LeaveReasonData: {
        leave_reason_name: "",
        leave_reason_description: "",
        leave_type_uuid: "",
        remarks: "",
        leave_reason_code: "",
        sequence: 1,
      },
    };
  },
  mounted() {
    // this.LeaveReasonData.leave_reason_name = this.$getCommonLangKey(
    //   this.companyLang
    // );
    // this.LeaveReasonData.leave_reason_description = this.$getCommonLangKey(
    //   this.companyLang
    // );
    this.getLeaveType();
    this.getDetail();
  },
  methods: {
    getLeaveType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_type",
        url: "/leave-type/get-list/",
      }).then((res) => {
        that.leaveTypeData = res.data;
      });
    },
    toBack: function () {
      // if (this.iSEdited) {
      //   this.iSEdited = false;
      // } else {
      this.$router.back();
      // }
    },
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_reason",
        url: "/leave-reason/get-details/",
        data: { uuid: this.$route.params.id },
      }).then((res) => {
        res.data["leave_reason_name_save"] = res.data.leave_reason_name;
        res.data.leave_reason_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.leave_reason_name
        );
        res.data["leave_reason_description_save"] =
          res.data.leave_reason_description;
        res.data.leave_reason_description = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.leave_reason_description
        );
        that.LeaveReasonData = res.data;
      });
    },
    toSave: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_reason",
        url: "/leave-reason/update/",
        data: {
          uuid: this.$route.params.id,
          leave_reason_name: this.$transCommonLangKey(
            this.LeaveReasonData.leave_reason_name,
            this.LeaveReasonData.leave_reason_name_save
          ),
          leave_reason_description: this.$transCommonLangKey(
            this.LeaveReasonData.leave_reason_description,
            this.LeaveReasonData.leave_reason_description_save
          ),
          sequence: this.LeaveReasonData.sequence,
          leave_reason_code: this.LeaveReasonData.leave_reason_code,
          leave_type_uuid: this.LeaveReasonData.leave_type_uuid,
          remarks: this.LeaveReasonData.remarks,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_leaveReason_list_updateLeaveReasonSuccessLabel"
          ),
          type: "success",
        });
        that.toBack(); //回到不能编辑状态
      });
    },
    toDelete: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_reason",
        url: "/leave-reason/delete/",
        data: { uuids: this.$route.params.id },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_leaveReason_list_deleteLeaveReasonSuccessLabel"
          ),
          type: "success",
        });
        that.toBack();
      });
    },
  },
};
</script>
